export enum ObservationDuration {
  PER_DAY = "per_day",
  PER_WEEK = "per_week",
  PER_MONTH = "per_month",
  PER_YEAR = "per_year",
}
